import { html, TemplateResult, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotsController } from '../../controllers/slots-controller';
import componentStyles from './sic-card-grid.css.lit';
import defaultVars from './css-variables/sic-card-grid-vars.css.lit';

export type BackgroundColor = 'none' | 'primary-lightest';

/**
 * @slot title
 * @slot body
 * @slot cta
 * @slot cards
 * @prop background color - only white or base-100 (bleeds to edge)
 */

@customElement('sic-card-grid')
export class SicCardGrid extends OutlineElement {
  private slotsController = new SlotsController(this);
  static styles = [componentStyles, defaultVars];

  @state() hasCtaSlot: boolean;

  firstUpdated() {
    this.hasCtaSlot = this.querySelector(':scope > [slot="cta"]') !== null;
  }

  conditionalSlots(
    slotName: string,
    renderInShadow = false,
    classes: string | null = null
  ) {
    if (this.slotsController.slotExists(slotName)) {
      return html` <div class="${slotName} ${classes}">
        ${renderInShadow
          ? html`${this.slotsController.renderInShadow(slotName)}`
          : html`<slot name=${slotName}></slot> `}
      </div>`;
    } else {
      return null;
    }
  }

  render(): TemplateResult {
    return html`
      <div class="container">
        <div class="content">
          <sic-heading level-size="6">
            ${this.conditionalSlots('title')}
          </sic-heading>
          ${this.conditionalSlots('body', false)}
          ${this.hasCtaSlot ? this.conditionalSlots('cta', false) : nothing}
        </div>
        <div class="card-wrapper">${this.conditionalSlots('cardgrid')}</div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-card-grid': SicCardGrid;
  }
}
